// src/api/locales.js
import axios from 'axios';

export async function fetchLocaleMessages(locale) {
    try {
        const response = await axios.get(`${process.env.VUE_APP_API}/www/public/getLang/${locale}`); // 根据实际接口调整
        return response.data.Data;
    } catch (error) {
        console.error(`Failed to load locale messages for ${locale}:`, error);
        return null;
    }
}